import React from 'react';

// Ícone de menu hamburguer simples em SVG
const HamburgerIcon = ({ color = '#414141', size = 28 }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="5" width="28" height="3.5" rx="1.75" fill={color} />
    <rect y="12.25" width="28" height="3.5" rx="1.75" fill={color} />
    <rect y="19.5" width="18" height="3.5" rx="1.75" fill={color} />
  </svg>
);

export default HamburgerIcon;